import HNSColors from "../../../../ui library/HNSColors";
import { SETTLEMENT_STYLES } from "../../style/styles";

import { formatFeeScheduleCurrency } from "./helpers";

export default function FeeScheduleAmountCard({ title, value }) {
  return (
    <div
      className="flex min-h-[52px] flex-1 items-center justify-between gap-2 rounded-[12px] border px-[10px] py-[4px]"
      style={{
        ...SETTLEMENT_STYLES.subtleBorder,
        backgroundColor: HNSColors.tertiary[900],
      }}
    >
      <span className="min-w-0 flex-none text-[13px]" style={{ color: HNSColors.neutrals[300] }}>
        {title}
      </span>
      <span
        className="min-w-0 flex-1 truncate text-right text-[16px] font-semibold"
        style={{ color: HNSColors.neutrals[100] }}
      >
        {formatFeeScheduleCurrency(value)}
      </span>
    </div>
  );
}
